import type * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type GetAssetNameByDeviceIdQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.AssetDeviceFilterInput>;
}>;


export type GetAssetNameByDeviceIdQuery = { assetDevices?: Maybe<{ __typename?: 'AssetDeviceCollectionSegment', totalCount: number, items?: Maybe<Array<{ __typename?: 'AssetDevice', id: string, deviceId: string, asset: { __typename?: 'Asset', id: string, assetMasterData?: Maybe<{ __typename?: 'AssetMasterData', id: string, generalItem?: Maybe<string> }> } }>> }> };


export const GetAssetNameByDeviceIdDocument = gql`
    query getAssetNameByDeviceId($where: AssetDeviceFilterInput) {
  assetDevices(where: $where) {
    totalCount
    items {
      id
      deviceId
      asset {
        id
        assetMasterData {
          id
          generalItem
        }
      }
    }
  }
}
    `;

/**
 * __useGetAssetNameByDeviceIdQuery__
 *
 * To run a query within a React component, call `useGetAssetNameByDeviceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetNameByDeviceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetNameByDeviceIdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAssetNameByDeviceIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAssetNameByDeviceIdQuery, GetAssetNameByDeviceIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAssetNameByDeviceIdQuery, GetAssetNameByDeviceIdQueryVariables>(GetAssetNameByDeviceIdDocument, options);
      }
export function useGetAssetNameByDeviceIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAssetNameByDeviceIdQuery, GetAssetNameByDeviceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAssetNameByDeviceIdQuery, GetAssetNameByDeviceIdQueryVariables>(GetAssetNameByDeviceIdDocument, options);
        }
export type GetAssetNameByDeviceIdQueryHookResult = ReturnType<typeof useGetAssetNameByDeviceIdQuery>;
export type GetAssetNameByDeviceIdLazyQueryHookResult = ReturnType<typeof useGetAssetNameByDeviceIdLazyQuery>;
export type GetAssetNameByDeviceIdQueryResult = Apollo.QueryResult<GetAssetNameByDeviceIdQuery, GetAssetNameByDeviceIdQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
export type Maybe<T> = Types.Maybe<T>;
